import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import { Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import styled from 'styled-components';
import React, { useState, useEffect } from 'react';
import { navigate, Link } from 'gatsby';
import { useStaticQuery, graphql } from 'gatsby';
import Search from '../Search';
import SubMenu from './subMenu';
import ImageComponent from '../../utils/imageComponent';
import LinkComponent from '../../utils/linkComponent';
import TopMenu from './topMenu';
import AuthModal from '../Auth/AuthModal';
import CustomContext from '../../../custom-context';
import { authAPI } from '../../utils/authAPI';
import * as styles from './topMenu.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

const searchIndices = [
	{ name: `Pages`, title: `Pages` },
	{ name: `Resources`, title: `Resources` },
	{ name: `Events`, title: `Events` },
	{ name: `Awards`, title: `Awards` },
	{ name: `Grants`, title: `Grants` },
	{ name: `ScholarshipReflections`, title: `Scholarship Reflections` },
];

const StyledLink = styled((props) => <LinkComponent {...props} />)`
	font-size: var(--font-size-base);
	margin: 0em 0.7em;
	/* color: var(--secondary_2) !important; */
	padding: 10px 0px;
	color: var(--secondary_6);
	text-decoration: none;
	white-space: nowrap;
	align-self: center;
	// mobile settings
	@media (max-width: 1199.5px) {
		font-weight: 600;
		margin-left: 0em;
		margin-right: 0em;
		align-self: start;
		width: 100%;
		display: block;
		overflow: visible;
		.mainMenu {
			top: 0px !important;
		}
	}
`;

const TopMenuLink = styled((props) => <LinkComponent {...props} />)`
	font-size: var(--font-size-base);
	margin-left: 1em;
	color: var(--secondary_2);
	padding: 0.3em;
	text-decoration: none;
	:hover {
		color: var(--link_color);
	}

	// mobile settings
	@media (max-width: 1199.5px) {
		color: var(--secondary_6);
		font-weight: 600;
		margin-left: 0em;
		margin-right: 0em;
		padding: 10px 0px;
		align-self: start;
		width: 100%;
		display: block;
		overflow: visible;
	}

	@media (max-width: 768px) {
		color: var(--secondary_6);
		font-weight: 600;
		margin-left: 0em;
		margin-right: 0em;
		padding: 10px 0px;
		align-self: start;
		width: 100%;
		display: block;
		overflow: visible;
	}
`;

const NavStyled = styled.div`
	position: sticky;
	top: -1px;
	z-index: 1000;

	.navbar-light .navbar-nav .nav-link {
		color: var(--secondary_2) !important;
		font-size: var(--font-size-base);
	}

	.mainMenu {
		background: ${(props) => props.bgColor};
		position: sticky;
		top: 0;
	}

	.navbar-light .navbar-brand {
		color: var(--secondary_6);
	}

	.navbar-light .navbar-toggler {
		border-color: var(--secondary_7) !important;
		color: var(--secondary_2) !important;
		order: 3;
	}
	.navbar-toggler-icon {
		background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255,255,255, 1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E");
	}

	.navbar-container {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		margin-bottom: 1em;
		margin-left: 0;
	}

	/* Override Bootstrap container padding for header */
	.container {
		padding-left: 0 !important;
		padding-right: 0 !important;
	}

	/* Add proper padding to navbar content */
	.navbar {
		padding-left: 1rem;
		padding-right: 1rem;
	}

	.navbar-left {
		display: flex;
		align-items: center;
	}

	.navbar-right {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	// tablets settings
	@media (max-width: 1199.5px) {
		.navbar-container {
			flex-direction: column;
			align-items: stretch;
			gap: 15px;
		}

		.navbar-left {
			justify-content: center;
		}

		.navbar-right {
			justify-content: space-between;
			align-items: center;
		}

		.navItem {
			border-bottom: 1px solid #ccc !important;
			border-radius: 0px;
			padding: 10px 0px;
			width: 100%;
		}

		.top-menu-mobile {
			border-top: 2px solid #ccc;
			margin-top: 10px;
			padding-top: 10px;
			display: flex;
			flex-direction: column;
			width: 100%;
		}

		.top-menu-mobile .navItem {
			width: 100%;
			display: block;
		}

		.top-menu-mobile .dropdown-menu {
			position: static !important;
			float: none !important;
			width: 100% !important;
			margin-top: 0 !important;
			background-color: #f8f9fa;
			border: none !important;
			box-shadow: none !important;
			padding: 0;
			z-index: 1001;
		}

		.mobile-buttons-container {
			display: flex;
			gap: 10px;
			align-items: center;
		}

		.mobile-buttons-container .btn {
			font-size: 14px;
			padding: 6px 12px;
		}
	}
	// mobile settings
	@media (max-width: 768px) {

		.navbar-container {
			flex-direction: column;
			align-items: stretch;
			gap: 10px;
		}

		.navbar-left {
			justify-content: center;
		}

		.navbar-right {
			justify-content: space-between;
			align-items: center;
		}

		.navItem {
			border-bottom: 1px solid #ccc !important;
			border-radius: 0px;
			padding: 10px 0px;
			width: 100%;
		}

		.top-menu-mobile {
			border-top: 0px solid #ccc;
			margin-top: 10px;
			padding-top: 10px;
			display: flex;
			flex-direction: column;
			width: 100%;
		}

		.top-menu-mobile .navItem {
			width: 100%;
			display: block;
		}

		.top-menu-mobile .dropdown-menu {
			position: static !important;
			float: none !important;
			width: 100% !important;
			margin-top: 0 !important;
			background-color: #f8f9fa;
			border: none !important;
			box-shadow: none !important;
			padding: 0;
			z-index: 1001;
		}

		.mobile-buttons-container {
			display: flex;
			gap: 8px;
			align-items: center;
		}

		.mobile-buttons-container .btn {
			width: 7em;
			text-align: center;
		}
	}

	// Hide top menu on mobile
	@media (max-width: 1199.5px) {
		.top-menu-container {
			display: none;
		}
	}

	// Wrap menu items to two lines from 1200px to 1399.98px
	@media (min-width: 1200px) and (max-width: 1399.98px) {
		.navbar-nav {
			flex-wrap: wrap !important;
			flex-direction: row !important;
		}

		/* Allow items to wrap to second line */
		.navbar-nav > * {
			flex: 0 1 auto;
			min-width: fit-content;
		}

		/* Ensure navbar collapse displays properly */
		.navbar-collapse {
			display: flex !important;
			flex-basis: auto !important;
		}
	}

	// Keep single line on 1400px and above
	@media (min-width: 1400px) {
		.navbar-nav {
			flex-wrap: nowrap !important;
		}
	}

	// Hide mobile buttons on desktop
	@media (min-width: 1200px) {
		.mobile-buttons-container {
			display: none;
		}
	}

	/* Safari-specific fix: height: 1px triggers proper flexbox alignment */
	body.safari & {
		height: 1px;
	}
`;

const Header = () => {
	const [expanded, setExpanded] = useState(false);
	const [showAuthModal, setShowAuthModal] = useState(false);
	const [authMode, setAuthMode] = useState('login');
	const [prefilledEmail, setPrefilledEmail] = useState('');
	const [memberInstitutes, setMemberInstitutes] = useState([]);
	const [loadingInstitutes, setLoadingInstitutes] = useState(false);
	const {
		user,
		handleLogout: logoutCtx,
		login: loginCtx,
	} = React.useContext(CustomContext);
	const isAuthenticated = !!user;
	const menuDataAndLogoData = useStaticQuery(graphql`
		query menuQueryAndStarpiAssetsLogo {
			strapiAsset {
				logo {
					alternativeText
					caption
					url
					localFile {
						childImageSharp {
							gatsbyImageData
						}
					}
				}
				header_background_colour
				button_shape
			}
			allStrapiNavigationPluginMainNavigation(sort: { order: ASC }) {
				nodes {
					items {
						path
						title
						type
						sub_menu_icon
						items {
							path
							title
							type
						}
					}
					order
					title
					type
					path
				}
			}
			allStrapiNavigationPlugin3(sort: { order: ASC }) {
				nodes {
					path
					title
					type
					items {
						path
						title
						type
						sub_menu_icon
						items {
							path
							title
							type
						}
					}
					order
				}
			}
		}
	`);
	const rawHeaderBg =
		menuDataAndLogoData?.strapiAsset?.header_background_colour;
	const headerBackground = rawHeaderBg?.startsWith('--')
		? `var(${rawHeaderBg})`
		: rawHeaderBg?.startsWith('var(')
		? rawHeaderBg
		: `var(--${rawHeaderBg})`;
	//console.log('Header background colour from Strapi:', headerBackground);

	// Determine button class based on shape
	const buttonClass =
		menuDataAndLogoData?.strapiAsset?.button_shape === 'rectangle'
			? 'btn-rectangle'
			: 'btn-round';

	const handleAuthClick = (mode) => {
		console.log('handleAuthClick called with mode:', mode);

		if (mode === 'login-aaf') {
			console.log('AAF login triggered');

			// Store current page URL for return after AAF login
			let currentUrl = '';
			if (typeof window !== 'undefined') {
				currentUrl = window.location.href;
				console.log('Storing return URL:', currentUrl);
				sessionStorage.setItem('returnURL', currentUrl);
			}

			// Redirect to AAF login with returnUrl parameter
			const aafUrl = new URL(process.env.GATSBY_AAF_LOGIN_URL);
			aafUrl.searchParams.set('returnUrl', currentUrl);
			console.log('AAF URL with returnUrl:', aafUrl.toString());

			console.log('Redirecting to AAF URL:', aafUrl.toString());
			window.location.href = aafUrl.toString();
		} else if (mode === 'login' || mode === 'join') {
			console.log('Regular login/join triggered');

			// Store current page URL for return after login
			if (typeof window !== 'undefined') {
				const currentUrl = window.location.href;
				sessionStorage.setItem('returnURL', currentUrl);
			}

			setAuthMode(mode);
			setShowAuthModal(true);
			setExpanded(false);
		}
	};

	const handleLogout = () => {
		try {
			logoutCtx?.();
		} catch (e) {}
		setExpanded(false);
	};

	// Fetch member institutes
	const fetchMemberInstitutes = async () => {
		setLoadingInstitutes(true);
		try {
			const data = await authAPI.getMemberInstitutes();

			if (data.memberInstitutes) {
				setMemberInstitutes(data.memberInstitutes);
			}
		} catch (error) {
			console.error('Error fetching member institutes:', error);
		} finally {
			setLoadingInstitutes(false);
		}
	};

	// Fetch member institutes on component mount
	useEffect(() => {
		fetchMemberInstitutes();
	}, []);

	// Listen for custom events from lock banner
	useEffect(() => {
		const handleOpenLoginModal = (event) => {
			const { type, prefilledEmail } = event.detail;
			setAuthMode(type);
			setPrefilledEmail(prefilledEmail || '');
			setShowAuthModal(true);
			setExpanded(false);
		};

		window.addEventListener('openLoginModal', handleOpenLoginModal);

		return () => {
			window.removeEventListener('openLoginModal', handleOpenLoginModal);
		};
	}, []);

	// Safari browser detection
	useEffect(() => {
		if (typeof window !== 'undefined') {
			const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
			if (isSafari) {
				document.body.classList.add('safari');
			} else {
				document.body.classList.remove('safari');
			}
		}
	}, []);

	return (
		<div className='sticky-header-container'>
			<div className='top-menu-container'>
				<TopMenu
					menu={menuDataAndLogoData?.allStrapiNavigationPlugin3?.nodes || []}
					bgColor={headerBackground}
					buttonShape={menuDataAndLogoData?.strapiAsset?.button_shape}
					onAuthClick={handleAuthClick}
					onLogout={handleLogout}
				/>
			</div>
			<NavStyled bgColor={headerBackground}>
				<Navbar
					variant='light'
					expand='xl'
					className='mainMenu'
					collapseOnSelect
					expanded={expanded}
					onToggle={() => setExpanded((expanded) => !expanded)}
					fixed='top'
				>
					<Container>
						<div className='navbar-container'>
							<div className='navbar-left'>
								<Navbar.Brand
									onClick={() => {
										setExpanded(false);
										navigate('/');
									}}
									style={{ cursor: 'pointer', width: '200px' }}
								>
									<ImageComponent
										imageItem={menuDataAndLogoData?.strapiAsset?.logo}
										alt='Logo'
									></ImageComponent>
								</Navbar.Brand>
							</div>

							<div className='navbar-right'>
								{/* Mobile buttons container - always visible on mobile */}
								<div className='mobile-buttons-container'>
									{isAuthenticated ? (
										<>
											<span
												style={{
													color: 'white',
												}}
												className='text-light me-2'
											>
												Hi, {user?.firstName || user?.first_name}!
												{user?.audience_segments &&
													user.audience_segments.length > 0 && (
														<>
															{' '}
															Your view is{' '}
															{user.audience_segments[0]?.name ||
																user.audience_segments[0]?.attributes?.name ||
																'Academic Staff'}
														</>
													)}
											</span>
											<Button
												variant='outline-light'
												className={buttonClass}
												onClick={handleLogout}
											>
												LOGOUT
											</Button>
											<Button
												variant='outline-light'
												className={buttonClass}
												as={LinkComponent}
												to={`/members-directory/${user?.people_slug}/`}
												style={{ textDecoration: 'none' }}
											>
												<FontAwesomeIcon
													icon={faUser}
													style={{ marginRight: '8px' }}
												/>
												My Profile
											</Button>
										</>
									) : (
										<>
											<Button
												variant='primary'
												className={buttonClass}
												as={Link}
												to='/login-help'
											>
												LOGIN
											</Button>
											<Button
												variant='primary'
												className={buttonClass}
												onClick={() => handleAuthClick('join')}
											>
												JOIN NOW
											</Button>
										</>
									)}
								</div>

								<Navbar.Toggle aria-controls='basic-navbar-nav' />
							</div>
						</div>

						<Navbar.Collapse id='basic-navbar-nav'>
							<Nav className='ms-auto'>
								<Search setExpanded={setExpanded} indices={searchIndices} />
								{/* Adding a multilevel navbar with dropdowns */}
								{menuDataAndLogoData?.allStrapiNavigationPluginMainNavigation?.nodes?.map(
									(menuItem) =>
										menuItem.items?.length > 0 ? (
											<SubMenu
												setExpanded={setExpanded}
												menuItem={menuItem}
											></SubMenu>
										) : (
											<StyledLink
												onClick={() => setExpanded(false)}
												className='navItem'
												to={menuItem.path}
												key={menuItem.title}
											>
												{menuItem.title}
											</StyledLink>
										)
								)}

								{/* Top menu items for mobile view */}
								<div className='top-menu-mobile d-xl-none'>
									{menuDataAndLogoData?.allStrapiNavigationPlugin3?.nodes?.map(
										(item) => {
											console.log(
												'Top menu item:',
												item.title,
												'has items:',
												item.items?.length > 0,
												'items:',
												item.items
											);
											// Test: Force render SubMenu for first item to see if it works
											if (item.title === 'Educate') {
												return (
													<SubMenu
														setExpanded={setExpanded}
														menuItem={item}
														key={item.title}
													/>
												);
											}
											return item.items?.length > 0 ? (
												<SubMenu
													setExpanded={setExpanded}
													menuItem={item}
													key={item.title}
												/>
											) : (
												<TopMenuLink
													onClick={() => setExpanded(false)}
													className='navItem'
													to={item.path}
													key={item.title}
												>
													{item.title}
												</TopMenuLink>
											);
										}
									)}
								</div>
							</Nav>
						</Navbar.Collapse>
					</Container>
				</Navbar>
			</NavStyled>

			{/* Authentication Modal */}
			<AuthModal
				show={showAuthModal}
				onHide={() => {
					console.log('=== HEADER onHide CALLED ===');
					console.log('Header onHide triggered at:', new Date().toISOString());
					setShowAuthModal(false);
					setAuthMode('login'); // Reset to default mode
					setPrefilledEmail(''); // Clear prefilled email
				}}
				mode={authMode}
				prefilledEmail={prefilledEmail}
				memberInstitutes={memberInstitutes}
				login={loginCtx}
			/>
		</div>
	);
};
export default Header;
